module.exports = __webpack_public_path__ + "static/media/contactless.62f8685e.png";